import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4c0bbcf1")

_pushScopeId("data-v-4c0bbcf1")
const _hoisted_1 = { slot: "fixed" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "border" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")

  return (_openBlock(), _createBlock("header", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_ion_buttons, {
        slot: "start",
        class: "buttons-box"
      }, {
        default: _withId(() => [
          _createVNode(_component_ion_button, {
            fill: "clear",
            onClick: $setup.goBack
          }, {
            default: _withId(() => [
              _createVNode(_component_ion_icon, {
                icon: $setup.arrowBack,
                color: "light"
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_3, [
        _createVNode("h3", null, _toDisplayString($props.title), 1)
      ])
    ]),
    _hoisted_4
  ]))
})